/**
 *
 * BankListModal
 *
 */

import React, { memo, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';
// import styled from 'styled-components';
import { Modal, Input } from 'semantic-ui-react';

import CustomIcon from 'components/CustomIcons';
import useClickOutside from 'utils/hooks';

function BankListModal({ list, closeModal, open }) {
  const [search, resetSearch] = useState('');
  const modalRef = useRef(null);

  const handleCloseClick = () => {
    closeModal();
    resetSearch('');
  };

  useClickOutside(modalRef, closeModal);

  const handleInputChange = (e, data) =>
    resetSearch(data.value && data.value.trim().toUpperCase());

  const sortedList = sortBy(list, [
    function sortFn(item) {
      return item.display.trim().toLowerCase();
    },
  ]);

  return (
    <Modal open={open} className="bank-list-modal" ref={modalRef}>
      <Modal.Header>
        <div className="header-wrapper">
          <div className="input-wrapper">
            <Input
              placeholder="Search Banks"
              fluid
              onChange={handleInputChange}
            />
          </div>
          {/* eslint-disable-next-line */}
          <div
            className="close-modal"
            data-event-name="BankListModal_Icon_Close"
            data-ignore-inner-text="true"
            onClick={handleCloseClick}
          >
            <CustomIcon componentName="CLOSE" />
          </div>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className="modal-content">
          {sortedList
            .filter(
              obj => !search || obj.display.toUpperCase().includes(search),
            )
            .map(obj => (
              <div key={obj.nick} className="list-item">
                <div className="icon-wrapper">
                  <CustomIcon componentName="NETBANKING" />
                </div>
                {obj.display}
              </div>
            ))}
        </div>
      </Modal.Content>
    </Modal>
  );
}

BankListModal.propTypes = {
  open: PropTypes.bool.isRequired,
  list: PropTypes.array.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default memo(BankListModal);
